import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { cn } from '../../utils/cn';

const EmptyState = ({
  icon = 'Inbox',
  title,
  description,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  className,
  size = 'default'
}) => {
  const sizeClasses = {
    sm: {
      container: 'py-8',
      iconSize: 40,
      iconContainer: 'w-16 h-16',
      title: 'text-base',
      description: 'text-xs'
    },
    default: {
      container: 'py-12',
      iconSize: 48,
      iconContainer: 'w-20 h-20',
      title: 'text-lg',
      description: 'text-sm'
    },
    lg: {
      container: 'py-16',
      iconSize: 64,
      iconContainer: 'w-24 h-24',
      title: 'text-xl',
      description: 'text-base'
    }
  };

  const currentSize = sizeClasses?.[size] || sizeClasses?.default;

  return (
    <div className={cn(
      'flex flex-col items-center justify-center text-center',
      currentSize?.container,
      className
    )}>
      <div className={cn(
        'rounded-full bg-muted/50 flex items-center justify-center mb-4',
        currentSize?.iconContainer
      )}>
        <Icon
          name={icon}
          size={currentSize?.iconSize}
          color="var(--color-muted-foreground)"
          strokeWidth={1.5}
        />
      </div>
      <h3 className={cn(
        'font-semibold text-foreground mb-2',
        currentSize?.title
      )}>
        {title}
      </h3>
      {description && (
        <p className={cn(
          'text-muted-foreground max-w-md mb-6',
          currentSize?.description
        )}>
          {description}
        </p>
      )}
      {(actionLabel || secondaryActionLabel) && (
        <div className="flex flex-col sm:flex-row items-center gap-3">
          {actionLabel && onAction && (
            <Button
              onClick={onAction}
              variant="default"
              size={size === 'sm' ? 'sm' : 'default'}
              iconName="Plus"
              iconPosition="left"
            >
              {actionLabel}
            </Button>
          )}
          {secondaryActionLabel && onSecondaryAction && (
            <Button
              onClick={onSecondaryAction}
              variant="outline"
              size={size === 'sm' ? 'sm' : 'default'}
            >
              {secondaryActionLabel}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;